export const PAGE_LABELS = {
	/** Shown while user/tenant or central config is still resolving (access gate). */
	GUARD_LOADING: 'Loading...',
	LOADING: 'Loading labels...',
	ERROR: 'Failed to load labels. Please try again.',
	DELETE_LABEL_SUCCESS: 'Label deleted'
} as const;
